import ROLES from '@/constants/roles'

export default function ({ redirect, $strapi }) {
  if ($strapi.user.role.type !== ROLES.ADMIN_UNEMPLOYED) {
    return redirect('/inicio')
  }
}
